import React from "react";
import { PathAnimationLoader } from "./Loaders/PathAnimationLoader";

function Fallbacksuspense({ isLogoVisible = false }) {
  return (
    <>
      <PathAnimationLoader />
    </>
  );
}

export default Fallbacksuspense;
